export class AclList {
    id: number;
    rolename:string;
    status:string;
}
